import { TarteaucitronInitOptions } from './tarteaucitron.types';

export const TARTEAUCITRON_INIT_OPTIONS: TarteaucitronInitOptions = {
  privacyUrl: '/mentions-legales',
  bodyPosition: 'bottom',
  hashtag: '#tarteaucitron',
  cookieName: 'tarteaucitron',
  orientation: 'bottom',
  groupServices: false,
  showAlertSmall: false,
  cookieslist: false,
  closePopup: false,
  showIcon: true,
  DenyAllCta: true,
  AcceptAllCta: true,
  highPrivacy: true,
  mandatory: true,
  mandatoryCta: true,
  googleConsentMode: true,
};

export const GTM_ACCOUNT_ID: string = process.env.REACT_APP_GTM_ACCOUNT ?? '';

export const GOOGLE_TAG_MANAGER_JOB = 'googletagmanager';
